import { createAction } from '@reduxjs/toolkit';
import { ActionType } from './types';

export const setHasShown = createAction<boolean>(ActionType.setHasShown);
